// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { ABOUT_US_MODULE, ABOUT_US_URL } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { AboutUsIndex } = lazily(() => import('pages/webpage/about-us'))

const aboutUsRoutes: IRoute[] = [
  {
    path: ABOUT_US_URL.INDEX,
    component: AboutUsIndex,
    layout: LAYOUT.DEFAULT,
    exact: true,
    meta: {
      module: ABOUT_US_MODULE,
      requireAuth: false,
      attrs: {
        label: 'aboutUs.aboutUs',
      },
    },
  },
]

export { aboutUsRoutes }
